import { render, staticRenderFns } from "./procurement.vue?vue&type=template&id=1a516381&scoped=true&"
import script from "./procurement.vue?vue&type=script&lang=js&"
export * from "./procurement.vue?vue&type=script&lang=js&"
import style0 from "./procurement.vue?vue&type=style&index=0&id=1a516381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a516381",
  null
  
)

export default component.exports